
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/previewer/components/previewerItem.scss.css.virtualfile';
        module.exports = {"item":"_item_15i40_1","overlay":"_overlay_15i40_5"};